// extracted by mini-css-extract-plugin
module.exports = {"titleSection":"PrivacyPolicy_titleSection__30aaG","tncSection":"PrivacyPolicy_tncSection__37ADg","tncItem":"PrivacyPolicy_tncItem__1J_h-"};